import React from 'react';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@producer/ui-kit';

import {
  Cell,
  Table,
  TableHeader,
  THead,
  Row,
} from '../../../components/table/styled-shared-table';
import { MapIcon } from '../../../components/icons/map-icon';
import { InlineTextArea } from '../../../components/editable-text/inline-text-area';
import { EmptyTablePlaceholder } from '../../../components/table/empty-table-placeholder';

import type { Step } from '../../../app/entities';

import styles from './locations-table.module.scss';
type LocationsTableProps = {
  step: Step;
  searchLocationOnMaps: (address: string) => void;
  handleMetaUpdate: (locationId: string, parking: string) => void;
};

export const LocationsTable: React.FC<LocationsTableProps> = observer(
  ({ step, searchLocationOnMaps, handleMetaUpdate }) => {
    if (!step.locations.length) {
      return (
        <EmptyTablePlaceholder description="No locations set in the shots of this shooting day." />
      );
    }

    return (
      <Table>
        <col
          style={{
            width: '10%',
          }}
        />

        <col
          style={{
            width: '18%',
          }}
        />

        <col
          style={{
            width: '16%',
          }}
        />

        <col
          style={{
            width: '53%',
          }}
        />

        <col
          style={{
            width: '3%',
          }}
        />

        <TableHeader>
          <THead className={styles['table-head-cell']}>Name</THead>

          <THead className={styles['table-head-cell']}>Address</THead>

          <THead className={styles['table-head-cell']}>Contact Person</THead>

          <THead className={styles['table-head-cell']}>Parking Instructions</THead>

          <THead className={styles['table-head-cell']} />
        </TableHeader>

        <tbody>
          {step.locationsWithMetaData.map((location) => (
            <Row key={location._id}>
              <Cell>{location.name}</Cell>

              <Cell
                onClick={() => {
                  if (!location.isSearchable || !location.formattedAddress) {
                    return;
                  }
                  searchLocationOnMaps(location.formattedAddress);
                }}
                style={{
                  cursor: location.isSearchable ? 'pointer' : 'default',
                }}
              >
                {location.formattedAddress || ''}
              </Cell>

              <Cell>{location.contact}</Cell>

              <Cell>
                <InlineTextArea
                  className={styles['parking-instructions']}
                  defaultValue={location.parking}
                  onSubmit={(e) => handleMetaUpdate(location._id, e.target.value)}
                  rows={2}
                />
                {location.nearestParking}
              </Cell>

              <Cell>
                {location.isSearchable && location.formattedAddress && (
                  <IconButton
                    icon={<MapIcon />}
                    disabled={!location.isSearchable}
                    onClick={() => searchLocationOnMaps(location.formattedAddress)}
                  />
                )}
              </Cell>
            </Row>
          ))}
        </tbody>
      </Table>
    );
  },
);
